module.exports = __webpack_public_path__ + "static/media/Instagram fav.1f70c255.png";